import { BalancePortalPage } from 'src/components/selfService/common/Balance/balance.types';

export const portalButtonText = 'View and pay invoices';

export const withNetTermsCopy = {
  title: 'Invoices and credit limit',
  description:
    "All details and management regarding your company's credit limit and invoicing periods are handled through the dedicated Balance portal.",
  invoices: {
    title: 'Invoices',
    description:
      'Current and previous invoices can be viewed in the Balance portal',
  },
  creditLimit: {
    title: 'Credit limit',
  },
} as const;

export const withoutNetTermsCopy = {
  title: 'Invoices',
  description:
    'View past and current invoices, and apply for net terms in the Balance portal.',
} as const;

export const getInvoicesPortalPage = (
  isOnNetTerms: boolean | null
): BalancePortalPage => {
  return isOnNetTerms === true
    ? BalancePortalPage.OUTSTANDING_INVOICES
    : BalancePortalPage.PAID;
};
